import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {useLocation, useHistory} from 'react-router-dom'
import {Tabs, TabList, TabPanels, Tab, TabPanel, TabIndicator} from '@chakra-ui/react'

// Get active tab index from current pathname
const getTabFromURL = (pathname) => {
    return pathname === '/registration' ? 1 : 0
}

/**
 * AuthTabs component for Login and Registration pages
 * Works with both /login and /registration routes using the same component
 * Provides smooth tab switching without component re-mounting
 */
const AuthTabs = ({loginContent, registrationContent}) => {
    const {pathname} = useLocation()
    const history = useHistory()

    // Handle tab changes - directly update URL
    const handleTabChange = (index) => {
        const newPath = index === 0 ? '/login' : '/registration'
        if (pathname !== newPath) {
            history.push(newPath)
        }
    }

    return (
        <Tabs variant="unstyled" index={getTabFromURL(pathname)} onChange={handleTabChange}>
            <TabList borderBottom="1px solid" borderColor="gray.50" gap={6} mx={{base: 4, lg: 0}}>
                <Tab px={0} py={1.5} fontSize="sm" lineHeight="18px">
                    <FormattedMessage id="auth_login.tab" defaultMessage="Login" />
                </Tab>
                <Tab px={0} py={1.5} fontSize="sm" lineHeight="18px">
                    <FormattedMessage id="auth_register.tab" defaultMessage="Register" />
                </Tab>
            </TabList>
            <TabIndicator mt="-2px" height="1px" bg="black" />
            <TabPanels>
                <TabPanel px={0} py={10}>
                    {loginContent}
                </TabPanel>
                <TabPanel px={0} py={10}>
                    {registrationContent}
                </TabPanel>
            </TabPanels>
        </Tabs>
    )
}

AuthTabs.propTypes = {
    loginContent: PropTypes.node.isRequired,
    registrationContent: PropTypes.node.isRequired
}

export default AuthTabs
